import authHeader from './auth.header.js';
import constants from './constants.js'
import { apiFetch as fetch } from './api.js'

const HOST_URL = constants.API_URL

// Retourne { ok, message } : le back renvoie 400/404/409 avec un `message` à afficher
async function postNode(path, body) {
    const response = await fetch(`${HOST_URL}/thematics/nodes/${path}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
        body: body ? JSON.stringify(body) : undefined,
    })

    if (response.ok) {
        return { ok: true }
    }

    let message = "Une erreur est survenue."
    try {
        const data = await response.json()
        if (data?.message) message = data.message
    } catch (e) {
        // réponse sans corps JSON
    }
    return { ok: false, status: response.status, message }
}

export const addNode = (node) => postNode('add', node)
export const updateNode = (node) => postNode('update', node)
export const reorderNodes = (parentId, orderedIds) => postNode('reorder', { parent_id: parentId, ordered_ids: orderedIds })
export const deleteNode = (id) => postNode(`delete/${id}`)
